export default {
  props: {
    name: {
      type: String,
      default: '',
      require: true
    }
  },
  data() {
    return {
      list: ['account-book', 'alert', 'api', 'appstore', 'audio', 'bank', 'bell', 'book', 'bug', 'bulb', 'calculator', 'build', 'calendar', 'camera', 'car', 'carry-out', 'cloud', 'code', 'compass', 'contacts', 'container', 'control', 'credit-card', 'crown', 'customer-service', 'dashboard', 'database', 'dislike', 'environment', 'experiment', 'eye-invisible', 'eye', 'file-add', 'file-excel', 'file-exclamation', 'file-image', 'file-markdown', 'file-pdf', 'file-ppt', 'file-text', 'file-unknown', 'file-word', 'file-zip', 'file', 'filter', 'fire', 'flag', 'folder-add', 'folder', 'folder-open', 'frown', 'funnel-plot', 'gift', 'hdd', 'heart', 'home', 'hourglass', 'solution', 'table', 'menu', 'gold', 'file-search', 'file-sync', 'file-done', 'tablet', 'switcher', 'read', 'project', 'profile', 'layout', 'reconciliation', 'file']
    };
  },
  methods: {
    iconItem(name) {
      this.$emit('iconOk', name);
    }
  }
};